import request from '@/utils/request'
import { TEMPLATE_STATE } from '@/enums'

export interface Launcher {
  engineTypeId: string
  engineTypeName: string
  version: string
  filePath: string
}

export function getLauncherList(): Promise<Launcher[]> {
  return request({
    url: '/launcher/list',
    method: 'get'
  })
}

export function getEngineType(): Promise<{ id: string; name: string }[]> {
  return request({
    url: '/engineType/listSimple',
    method: 'get'
  })
}

/** 底板 */
export interface Template {
  id: string
  coverUrl: string
  updateTime: string
  basicName: string
  fileOssPath: string
  fileSize: string
  engineVersion: string
  engineVersionId: string
  tags: { id: string; name: string }[]
  detailUrls: string[]
  basicState: TEMPLATE_STATE
  expectation: number
}

export function getTemplateList(params): Promise<{ records: Template[]; totalCount: string }> {
  return request({
    url: '/basicTemplate/page',
    method: 'get',
    params
  })
}

export function getTemplateDetail(params: { id: string }): Promise<Template> {
  return request({
    url: '/basicTemplate/getById',
    method: 'get',
    params
  })
}

export function expectTemplate(data: { id: string; flag: number }) {
  return request({
    url: '/basicTemplate/thumbsUp',
    method: 'post',
    data
  })
}
